export default {
  name: 'asset-based-fee-schedule-metadata-mixin',
  computed: {
    maxDiscountDescription() {
      if (!this.schedule.allowMaxDiscount) {
        return this.translate('noDiscountAllowed');
      }
      return this.translate('discountAllowedMeta', {
        maxDiscount: this.formatNumber(this.schedule.maxDiscount, 'shortDecimal'),
      });
    },
  },
};
